import { useState } from "react";
import styles from "../assets/css/login.module.css";
import logo from "../assets/images/polyglow-logo.svg";
import { loginIcons } from "../assets/images/login";
import { register as registerUser } from "../services/auth";

const Register = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!name || !email || !password) {
      setError("Merci de remplir tous les champs.");
      return;
    }

    try {
      setLoading(true);

      // username = name, email tel quel
      await registerUser({
        email,
        password,
        username: name,
      });

      setSuccess(
        "Compte créé avec succès. Vous pouvez maintenant vous connecter."
      );
      // Option : redirection automatique
      // navigate("/login");
    } catch (err) {
      setError(
        err.message ||
          "Erreur lors de la création du compte (droits insuffisants ?)."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.logPage}>
      <header className={styles.homeHeader}>
        <a className={styles.logoAnaimation} href="/">
          <img
            src={logo}
            className={styles.logoAnaimation}
            alt="Logo Polyglow"
          />
        </a>
      </header>

      <div className={styles.content}>
        <div className={styles.title}>
          <p className={styles.noMargin}>Créer votre compte</p>
        </div>

        {/* 👉 on ajoute juste onSubmit, le reste du markup reste identique */}
        <form className={styles.logInputs} onSubmit={handleSubmit}>
          <div className={styles.overlap}>
            <img
              className={styles.icon}
              src={loginIcons.user}
              alt="User Icon"
            />
            <input
              type="text"
              id="prenom"
              name="prenom"
              placeholder="Prénom"
              required
              className={styles.jade}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className={styles.overlap}>
            <img
              className={styles.icon}
              src={loginIcons.mail}
              alt="Mail Icon"
            />
            <input
              type="email"
              id="AdresseEmail"
              name="AdresseEmail"
              placeholder="Adresse email"
              required
              className={styles.jade}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className={styles.overlap}>
            <img
              className={styles.icon}
              src={loginIcons.lock}
              alt="Lock Icon"
            />
            <input
              type={showPassword ? "text" : "password"}
              id="MotDePasse"
              name="MotDePasse"
              placeholder="Mot de passe"
              required
              className={styles.textWrapper3}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <img
              className={styles.solidStatusEye}
              src={showPassword ? loginIcons.eyeCrossed : loginIcons.eye}
              alt="Eye Icon"
              onClick={togglePasswordVisibility}
              style={{ cursor: "pointer" }}
            />
          </div>

          {/* Messages (inline style pour ne pas toucher au CSS global) */}
          {error && (
            <p style={{ color: "red", marginTop: "8px", fontSize: "0.9rem" }}>
              {error}
            </p>
          )}
          {success && (
            <p
              style={{ color: "green", marginTop: "8px", fontSize: "0.9rem" }}
            >
              {success}
            </p>
          )}

          <button
            type="submit"
            id="Envoyer"
            className={styles.signIn}
            style={{ cursor: loading ? "wait" : "pointer" }}
            disabled={loading}
          >
            <p>{loading ? "Création..." : "S'inscrire"}</p>
            <div className={styles.iconWrapper}>
              <img
                className={styles.icon2}
                src={loginIcons.arrow}
                alt="Connexion"
              />
            </div>
          </button>
        </form>

        <div className={styles.vectorsDeco}>
          <div className={styles.vector}></div>
          <div className={styles.vector}></div>
          <div className={styles.vector}></div>
          <div className={styles.vector}></div>
        </div>
      </div>
    </div>
  );
};

export default Register;
